<template>
  <div>
    <Miniform />
  </div>
</template>

<script>
import Miniform from '@/components/Miniform'
import { cleanUrlParam } from '@/utils'

export default {
  name: 'Search',
  beforeRouteEnter(to, from, next) {
    if (to.query.s) {
      const query = cleanUrlParam(to.query.s)
      next({name: 'results', params: {trackingNumber: query}})
    } else {
      next()
    }
  },
  components: {
    Miniform
  }
}
</script>